import { useIntl } from 'react-intl';
import { Selector, SelectorOptionPropsInterface } from 'sonata-react-components';

// 'pendingActivation' | 'pendingValidation' | 'validationDisapproved' removed from this filter (MTF-717):
// they only apply to line items created via "reuse Campaign Template", pending manual backoffice
// review after reuse (see campaignTemplate.service.js _resetCampaignValidationStatus and
// paginatorQuery.js buildAndOrCampaignsParams). Re-add here if that validation flow is used again.
const status = ['launching', 'active', 'schedulePending', 'paused', 'published', 'draft', 'finished'];

type Props = {
  onFilterStatus?: (state: { id: string; value: any }[]) => { id: string; value: any }[];
  value?: string;
};

export default function Status({ onFilterStatus, value }: Props) {
  const { formatMessage } = useIntl();

  const options = status.map(s => ({
    id: s,
    label: formatMessage({
      defaultMessage: s !== 'launching' ? s.charAt(0).toUpperCase() + s.slice(1) : 'Updating',
      id: `campaignPlans.filters.status.${s}`
    }),
    value: s
  }));

  const valueOption = value
    ? [
        {
          id: value,
          label: formatMessage({
            defaultMessage: value !== 'launching' ? value.charAt(0).toUpperCase() + value.slice(1) : 'Updating',
            id: `campaignPlans.filters.status.${value}`
          }),
          value
        }
      ]
    : [];

  const handleChange = (option: SelectorOptionPropsInterface) => {
    const filter = [
      {
        id: 'status',
        value: option.value
      }
    ];
    onFilterStatus?.(filter);
  };

  return (
    <Selector<SelectorOptionPropsInterface>
      label={formatMessage({
        defaultMessage: 'Status',
        id: 'campaignPlans.filters.status.label'
      })}
      onChange={handleChange}
      options={options}
      showDeselectOption
      type="simple"
      value={valueOption}
    />
  );
}
